<template style="font-family: Times New Roman">
  <div>
    <v-card
      v-if="
        checkaccessdata.is_viewer == false &&
        checkaccessdata.is_checker == false
      "
      class="mt-16"
      flat
    >
      <v-row justify="center" align="center">
        <v-card-title class="red--text">
          <h2>Access Denied</h2>
        </v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card flat v-else class="mt-3">
      <v-card class="ma-2">
        <v-row>
          <v-card-text>
            <v-row class="ml-1">
              <v-col cols="12" sm="12" xl="3" xs="12" lg="3" md="3">
                <v-dialog
                  ref="dialogEnd"
                  v-model="modalEnd"
                  :return-value.sync="end_data"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      color="primary"
                      dense
                      class="ml-n2 mx-2 mt-1"
                      v-model="end_data"
                      label="From"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                    <!-- /*---*/ -->
                  </template>
                  <v-date-picker
                    v-model="end_data"
                    scrollable
                    :max="currentDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalEnd = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="
                        setMinMaxToDate();
                        $refs.dialogEnd.save(end_data);
                      "
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog></v-col
              >
              <v-col cols="12" sm="12" xl="3" xs="12" lg="3" md="3">
                <v-dialog
                  ref="dialogEnd1"
                  v-model="modalEnd1"
                  :return-value.sync="enddata"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      color="primary"
                      dense
                      class="ml-n2 mx-2 mt-1"
                      v-model="enddata"
                      label="To"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                    <!-- /*---*/ -->
                  </template>
                  <v-date-picker
                    v-model="enddata"
                    scrollable
                    :max="maxEndDate"
                    :min="end_data"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalEnd1 = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogEnd1.save(enddata)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog></v-col
              >

              <v-col cols="12" sm="12" xl="2" xs="12" lg="2" md="2">
                <v-select
                  v-model="usernames"
                  dense
                  style="width: 900px"
                  class="ml-n2 mx-2 mt-1"
                  item-text="full_name"
                  item-value="userid"
                  label="User name"
                  outlined
                  :items="UserList"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="12" xl="2" xs="12" lg="2" md="2">
                <v-select
                  v-model="transectnStatus"
                  dense
                  style="width: 900px"
                  class="ml-n2 mx-2 mt-1"
                  item-text="name"
                  item-value="value"
                  :items="transectionList"
                  label="Transaction Type"
                  outlined
                ></v-select>
              </v-col>

              <!-- <v-col cols="1" class="mt-1">
              
              </v-col> -->
              <v-col cols="12" sm="12" xl="2" xs="12" lg="2" md="2">
                <v-btn
                  color="primary"
                  :loading="downloadLoading"
                  @click="openFilterDialog()"
                  class="ml-n2 mx-2 mt-1"
                  :disabled="checkaccessdata.has_download == false"
                >
                  <v-icon left dark>mdi-download</v-icon>EXPORT
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="mt-n5 ml-1">
              <v-col
                cols="12"
                sm="12"
                xl="3"
                xs="12"
                lg="3"
                md="3"
                class="ml-n2 mx-2 mt-3"
              >
                <v-select
                  v-model="status"
                  dense
                  style="width: 900px"
                  class="ml-0 mx-0 lg-2"
                  item-text="name"
                  item-value="value"
                  :items="statusitems"
                  label="Expense status"
                  outlined
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                xl="3"
                xs="12"
                lg="3"
                md="3"
                class="ml-n2 mx-2 mt-3"
              >
                <v-text-field
                  dense
                  outlined
                  v-model="search"
                  @keyup.enter="getFundDetails(end_data, enddata)"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="12"
                xl="2"
                xs="12"
                lg="2"
                md="2"
                class="ml-n2 mx-2 mt-3"
              >
                <v-btn
                  @click="getFundDetails(end_data, enddata)"
                  color="primary"
                  class="elevation-0 ml-2"
                >
                  APPLY
                </v-btn>
              </v-col>
            </v-row>

            <v-col cols="12" md="12" lg="12" xl="12" sm="12" xs="12">
              <v-data-table
                :headers="headers"
                :items="cardtransactions"
                dense
                class="caption"
                item-key="name"
                :options.sync="pagination"
                :items-per-page="itemsPerPage"
                @update:options="getFundDetailsPagination(end_data, enddata)"
                :no-data-text="Nodata"
              >
                <template v-slot:[`item.sl_no`]="{ item }">
                  <span class="caption">{{
                    cardtransactions.indexOf(item) + 1
                  }}</span>
                </template>
                <template v-slot:[`item.expense_status`]="{ item }">
                  <div v-if="item.txn_type == 'Wallet Debit' || item.txn_type == 'Wallet Credit'">
                    <div class="caption black--text font-weight-medium">
                   -
                    </div>
                    </div>
                    <div v-else>
                  <div v-if="item.expense_status == 0">
                    <div class="caption orange--text font-weight-medium">
                      UNCLAIMED
                    </div>
                    <!-- <div v-else>-</div> -->
                  </div>

                  <div v-if="item.expense_status == 1">
                    <div class="caption green--text font-weight-medium">
                      APPROVED
                    </div>
                    <!-- <div v-else>-</div> -->
                  </div>
                  <div v-if="item.expense_status == 2">
                    <div class="caption red--text font-weight-medium">
                      REJECTED
                    </div>
                    <!-- <div v-else>-</div> -->
                  </div>
                  <div v-if="item.expense_status == 6">
                    <div class="caption blue--text font-weight-medium">
                      PERSONAL
                    </div>
                    <!-- <div v-else>-</div> -->
                  </div>
                  <div v-if="item.expense_status == 7">
                    <div class="caption blue--text font-weight-medium">
                      OFFICIAL
                    </div>
                    <!-- <div v-else>-</div> -->
                  </div>
                  <div v-if="item.expense_status == 3">
                    <div class="caption blue--text font-weight-medium">
                      IN PROGRESS
                    </div>
                    <!-- <div v-else>-</div> -->
                  </div>
                  <div v-if="item.expense_status == 4">
                    <div class="caption primary--text font-weight-medium">
                      ALL TRANSACTIONS
                    </div>
                    <!-- <div v-else>-</div> -->
                  </div>
                </div>
                </template>
                <template v-slot:[`item.settlement_status`]="{ item }">
                  <div v-if="item.txn_type == 'Wallet Debit' || item.txn_type == 'Wallet Credit'">
                    <div class="caption black--text font-weight-medium">
                   -
                    </div>
                    </div>
                    <div v-else>
                  <span
                    class="caption orange--text"
                    v-if="item.settlement_status == 'PENDING'"
                    >PENDING
                  </span>
                  <span
                    class="caption green--text"
                    v-if="item.settlement_status == 'SETTLED'"
                    >SETTLED
                  </span>
                  <span v-if="item.settlement_status == ''">- </span>
                  </div>
                </template>
                <template v-slot:[`item.txn_type`]="{ item }">
                  <!-- <span class="caption" v-if="item.txn_type == 'WALLET_DEBIT'"
            >Wallet Debit
          </span> -->
                  <!-- <span class="caption" v-if="item.txn_type == 'WALLET_CREDIT'"
            >Wallet Credit
          </span> -->
                  <span class="caption">{{ item.txn_type }} </span>

                  <br />
                  <span class="caption">{{ item.txn_timestamp }}</span>
                </template>

                <template v-slot:[`item.txn_description`]="{ item }">
                  <span class="caption">{{ item.txn_description }}</span>
                </template>
                <template v-slot:[`item.trxn_status`]="{ item }">
                  <span
                    class="caption green--text"
                    v-if="item.trxn_status == 'SUCCESS'"
                    ><b>SUCCESS</b>
                  </span>
                  <span
                    class="caption red--text"
                    v-else-if="item.trxn_status == 'FAILED'"
                    ><b>FAILED</b>
                  </span>

                  <span class="caption" v-else>- </span>
                  <br />
                  <span class="caption">{{ item.txn_time }} </span>
                </template>
                <template v-slot:[`item.txn_time`]="{ item }">
                  <span class="caption">{{ item.txn_time }}</span>
                </template>
                <template v-slot:[`item.card_name`]="{ item }">
                  <span class="caption"
                    ><b>{{ item.card_name }}</b></span
                  >
                  <br />
                  <span class="caption">({{ item.sub_card_type }})</span>
                </template>

                <template v-slot:[`item.merchant_name`]="{ item }">
                  <div v-if="item.merchant_name != null">
                    <span class="caption">{{ item.merchant_name }}</span>
                  </div>
                  <div v-else>
                    <span class="caption">-</span>
                  </div>
                </template>
                <template v-slot:[`item.txn_amount`]="{ item }">
                  <!-- <span class="caption">{{ item.txn_amount }}</span> -->
                  <div v-if="item.txn_amount != null"></div>
                  <span
                    class="caption red--text"
                    v-if="item.type == 'DEBIT' || item.type == 'D'"
                    >- {{ item.txn_amount }}
                  </span>

                  <span
                    class="caption green--text"
                    v-if="item.type == 'CREDIT' || item.type == 'C'"
                    >+ {{ item.txn_amount }}
                  </span>
                </template>
                <template v-slot:[`item.billing_amount`]="{ item }">
                  <!-- <span class="caption">{{ item.txn_amount }}</span> -->
                  <div v-if="item.billing_amount != null">
                    <span
                      class="caption red--text"
                      v-if="item.type == 'DEBIT' || item.type == 'D'"
                      >- {{ item.billing_amount }}
                    </span>

                    <span
                      class="caption green--text"
                      v-if="item.type == 'CREDIT' || item.type == 'C'"
                      >+ {{ item.billing_amount }}
                    </span>
                  </div>
                  <div v-else>-</div>
                </template>
                <template v-slot:[`item.fee_amount`]="{ item }">
                  <!-- <span class="caption">{{ item.txn_amount }}</span> -->
                  <div
                    v-if="
                      item.fee_amount != null &&
                      item.txn_type == 'ATM Cash Withdrawal'
                    "
                  >
                    <span class="caption red--text"
                      >- {{ item.fee_amount }}
                    </span>
                  </div>
                  <div v-else>-</div>
                </template>
                <template v-slot:[`item.txn_currency`]="{ item }">
                  <!-- <span class="caption">{{ item.txn_amount }}</span> -->
                  <div v-if="item.txn_currency != null" class="ml-n6">
                    <span class="caption black--text"
                      >{{ item.txn_currency }}
                    </span>
                  </div>
                  <div v-else>-</div>
                </template>
                <template v-slot:[`item.created_on`]="{ item }">
                  <span class="caption">{{ item.created_on }}</span>
                </template>
                <template v-slot:[`item.account_balance`]="{ item }">
                  <span class="caption">{{ item.account_balance }}</span>
                </template>
                <template v-slot:[`item.card_balance`]="{ item }">
                  <span class="caption">{{ item.card_balance }}</span>
                </template>
                <template v-slot:[`item.user_name`]="{ item }">
                  <span class="caption"
                    ><b>{{ item.user_name }}</b></span
                  >
                  <br />
                  <span class="caption">{{ item.mobile_number }}</span>
                  <!-- <span class="caption">{{ item.mobile_no }}</span> -->
                  <span class="caption" v-if="item.user_name == null">-</span
                  ><br />
                </template>
                <template v-slot:[`item.View`]="{ item }">
                  <span>
                    <v-icon
                      small
                      class="ml-2"
                      @click="showContent(item)"
                      v-on="on"
                      color="primary"
                      >mdi-eye</v-icon
                    ></span
                  ><span>
                    <v-icon
                      small
                      class="ml-2"
                      @click="newww(item)"
                      v-on="on"
                      v-if="
                        (item.txn_type == 'Purchase' ||
                          item.txn_type == 'Ecom Purchase' ||
                          item.txn_type == 'ATM Cash Withdrawal') &&
                        item.settlement_status == 'SETTLED' &&
                        item.trxn_status != 2 &&
                        item.expense_status == 0 &&
                        checkaccessdata.is_super_user == true
                      "
                      color="green"
                      >mdi-pencil</v-icon
                    ></span
                  >
                </template>
              </v-data-table>
            </v-col>
          </v-card-text>
        </v-row>

        <OverleyProccessg :overlay="overlay" />
      </v-card>
      <div>
        <v-dialog v-model="approveRej" max-width="600">
          <v-card>
            <v-toolbar flat class="header" dense dark>
              <v-icon>mdi-checkbox-marked-circle-outline</v-icon
              ><span class="ml-3">Transaction Approval</span>

              <v-spacer></v-spacer>
              <v-btn class text dark @click="approveRejDialog()">
                <v-icon small color="white" class="ml-8"> mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-card
                elevation="1"
                width="600"
                height="auto"
                class="mb-4 mt-6"
                rounded="xl"
              >
                <v-row>
                  <v-col cols="12" md="6" lg="6" xl="6">
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">User Name</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="
                            Trans.user_name != null && Trans.user_name != ''
                          "
                        >
                          {{ Trans.user_name }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Transaction Type</b>
                        </span>
                        <br />
                        <span class="caption" v-if="Trans.txn_type != null">
                          {{ Trans.txn_type }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Transaction Amount</b>
                        </span>
                        <br />
                        <span class="caption" v-if="Trans.txn_amount != null">
                          {{ Trans.txn_amount }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" md="6" lg="6" xl="6">
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Merchant Name</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="Trans.merchant_name != null"
                        >
                          {{ Trans.merchant_name }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Transacted On</b>
                        </span>
                        <br />
                        <span class="caption" v-if="Trans.txn_time != null">
                          {{ Trans.txn_time }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Billing Amount</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="Trans.billing_amount != null"
                        >
                          {{ Trans.billing_amount }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="mt-3 ml-3 mr-3">
                  <v-col cols="12" sm="12" xs="12" md="12" lg="12">
                    <v-form ref="form">
                      <v-textarea
                        v-model="reason"
                        :rules="remarkRule"
                        outlined
                        label="Remark"
                        densePersonal
                        rows="1"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <!-- <v-btn @click="sdf()" color="primary" dense text
                >Partially Approve</v-btn
              > -->
                  <v-btn @click="rejectTrans()" color="secondary" dense text
                    >Mark As Personal</v-btn
                  >
                  <v-btn
                    @click="approveRejTrans()"
                    color="success"
                    dense
                    text
                    :rules="remarkRule"
                  >
                    Mark As Official
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="MessageStatus" width="530" height="300">
          <v-card width="530" height="120" class="overflow-hidden">
            <v-card-subtitle
              class="subtitle-1 ml-5 mt-6 primary--text"
              align="center"
              justif="center"
            >
              Your export is being processed<br />
              you can either wait or come back to
              <u @click="ArchiveMode()" class="blue--text cursor">ARCHIVE</u>
            </v-card-subtitle>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="FilterDialog" width="1000">
          <v-card width="1000" class="overflow-hidden">
            <v-row class="mt-4 ml-2 mr-2">
              <!-- <v-col lg="2">
            <label class="caption">Status</label>
            <v-select
              v-model="statusTypeArchive"
              :items="statusList"
              dense
              item-text="name"
              item-value="value"
              solo
              label="Status"
            ></v-select>
          </v-col> -->
              <v-col cols="12" sm="12" xl="2" xs="12" lg="2" md="2">
                <v-dialog
                  ref="dialogEnd"
                  v-model="modalEndArchive"
                  :return-value.sync="end_data_archive"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      color="primary"
                      dense
                      class="ml-0 mx-0 lg-2 mt-1"
                      v-model="end_data_archive"
                      label="From"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                    <!-- /*---*/ -->
                  </template>
                  <v-date-picker
                    v-model="end_data_archive"
                    scrollable
                    :max="currentDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalEndArchive = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="
                        setMinMaxToDateArchive();
                        $refs.dialogEnd.save(end_data_archive);
                      "
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog></v-col
              >
              <v-col cols="12" sm="12" xl="2" xs="12" lg="2" md="2">
                <v-dialog
                  ref="dialogEnd1"
                  v-model="modalEnd1Archive"
                  :return-value.sync="enddata_archive"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      color="primary"
                      dense
                      class="ml-0 mx-0 lg-2 mt-1"
                      v-model="enddata_archive"
                      label="To"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                    <!-- /*---*/ -->
                  </template>
                  <v-date-picker
                    v-model="enddata_archive"
                    scrollable
                    :max="maxEndDateArchive"
                    :min="end_data_archive"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="modalEnd1Archive = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogEnd1.save(enddata_archive)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog></v-col
              >
              <v-col cols="12" sm="12" xl="2" xs="12" lg="2" md="2">
                <v-select
                  v-model="usernames_archive"
                  dense
                  style="width: 900px"
                  class="ml-0 mx-0 lg-2 mt-1"
                  item-text="full_name"
                  item-value="userid"
                  label="User name"
                  outlined
                  :items="UserList"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" xl="2" xs="12" lg="2" md="2">
                <v-select
                  v-model="transectnStatus_archive"
                  dense
                  style="width: 900px"
                  class="ml-0 mx-0 lg-2 mt-1"
                  item-text="name"
                  item-value="value"
                  :items="transectionList"
                  label="Transaction Type"
                  outlined
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                xl="2"
                xs="12"
                lg="2"
                md="2"
                v-if="
                  transectnStatus_archive != 1 && transectnStatus_archive != 7
                "
              >
                <v-select
                  v-model="status_archive"
                  dense
                  style="width: 900px"
                  class="ml-0 mx-0 lg-2 mt-1"
                  item-text="name"
                  item-value="value"
                  :items="statusitems"
                  label="Expense status"
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" xl="1" xs="12" lg="1" md="1">
                <v-btn
                  dark
                  color="primary"
                  class="ml-0 mx-0 lg-2 mt-1"
                  @click="getMessageDialog()"
                >
                  APPLY
                </v-btn>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                dark
                @click="closeFilterDialog()"
                small
                class="mt-10"
                >Dismiss</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-card>
    <v-dialog v-model="contentDialog" max-width="1200" class="overflow-hidden">
      <v-card height="auto" class="overflow-hidden">
        <v-toolbar flat class="header" dense dark height="55">
          <v-icon>mdi-details</v-icon>
          <span class="ml-3">Transaction Details - {{ UserName }}</span>

          <v-spacer></v-spacer>
          <!-- <span class="ml-3"> MerchantName</span><br /> -->
          <div class="mt-2 mb-2">
            <span class="ml-3 caption">Merchant Name - {{ MerchantName }}</span
            ><br />
            <span class="ml-3 caption">Transaction On - {{ txntime }}</span>
          </div>
          <v-btn class text dark @click="contentDialogclose()">
            <v-icon small color="white" class="ml-8"> mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-row class="mt-6 ml-3">
          <v-col cols="12" md="8" lg="8" xl="8">
            <v-card
              elevation="1"
              height="auto"
              class="mb-6"
              width="700"
              rounded="xl"
            >
              <v-row>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Transacted Amount</b>
                      </span>
                      <br />

                      <span
                        class="caption green--text"
                        v-if="Typeoftxn == 'CREDIT' || Typeoftxn == 'C'"
                        >+ {{ TxnAmount }}
                      </span>
                      <span
                        class="caption red--text"
                        v-if="Typeoftxn == 'DEBIT' || Typeoftxn == 'D'"
                        >- {{ TxnAmount }}
                      </span>

                      <span class="caption">{{ TxnCrrncy }}</span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Transaction Type</b>
                      </span>
                      <br />
                      <span class="caption" v-if="TxnType != null">
                        {{ TxnType }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>

                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Transaction Status</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="contentDetails.status_description != null"
                      >
                        {{ contentDetails.status_description }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>

                  <!-- <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Message Type</b>
                      </span>
                      <br />
                      <span
                        v-if="
                          contentDetails.messsage_type != '' ||
                          contentDetails.messsage_type
                        "
                        class="caption"
                        >{{ contentDetails.messsage_type }}</span
                      >

                      <span class="caption ml-2" v-else> - </span></v-col
                    >
                  </v-row> -->

                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Settlement Status</b>
                      </span>
                      <br />
                      <div v-if="TxnType == 'Wallet Debit' || TxnType == 'Wallet Credit'">
                    <div class="caption black--text font-weight-medium">
                   -
                    </div>
                    </div>
                    <div v-else>
                      <span
                        class="caption orange--text"
                        v-if="SettleStatus == 'PENDING'"
                        >PENDING
                      </span>
                      <span
                        class="caption green--text"
                        v-if="SettleStatus == 'SETTLED'"
                        >SETTLED
                      </span>
                      <span v-if="SettleStatus == ''">- </span>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Txn Unique Id</b>
                      </span>
                      <br />
                      <span
                        v-if="
                          contentDetails.txn_uniqueid != '' &&
                          contentDetails.txn_uniqueid != null
                        "
                        class="caption"
                        >{{ contentDetails.txn_uniqueid }}</span
                      >

                      <span class="caption ml-2" v-else> - </span></v-col
                    >
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" lg="6" xl="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12" v-if="BillingAmt">
                      <span class="subtitle-2">
                        <b class="primary--text">Billing Amount</b>
                      </span>
                      <br />

                      <div v-if="BillingAmt != null">
                        <span
                          class="caption green--text"
                          v-if="Typeoftxn == 'CREDIT' || Typeoftxn == 'C'"
                          >+ {{ BillingAmt }}
                        </span>
                        <span
                          class="caption red--text"
                          v-if="Typeoftxn == 'DEBIT' || Typeoftxn == 'D'"
                          >- {{ BillingAmt }}
                        </span>

                        <span class="caption">{{ BillingCrrncy }}</span>
                      </div>
                      <div v-else>-</div>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">RR Number</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="
                          contentDetails.rr_number ||
                          contentDetails.rr_number != '' ||
                          contentDetails.rr_number != null
                        "
                      >
                        {{ contentDetails.rr_number }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <!-- <v-row
                    class="ml-3"
                    v-if="contentDetails.txn_type != 'WALLET_DEBIT'"
                  >
                    <v-col
                      cols="12"
                      md="12"
                      lg="12"
                      v-if="contentDetails.txn_type != 'WALLET_CREDIT'"
                    >
                      <span class="subtitle-2">
                        <b class="primary--text">Merchant City</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="contentDetails.merchant_city != null"
                      >
                        {{ contentDetails.merchant_city }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row> -->
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Merchant Country</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="contentDetails.merchant_country != null"
                      >
                        {{ contentDetails.merchant_country }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>

                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">POS Environment</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="contentDetails.pos_environment != null"
                      >
                        {{ contentDetails.pos_environment }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" lg="4" xl="4">
            <v-card
              elevation="1"
              :height="urlimage.length > 1 ? 'auto' : '385'"
              width="350"
              rounded="xl"
              class="mb-6 mt-2"
              ><v-row>
                <v-col cols="12" md="12" lg="12" xl="12">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Expense Name</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="
                          contentDetails.expense_name != '' &&
                          contentDetails.expense_name != null
                        "
                      >
                        {{ contentDetails.expense_name }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Category Name</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="
                          contentDetails.category_name != '' &&
                          contentDetails.category_name != null
                        "
                      >
                        {{ contentDetails.category_name }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">User Comments</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="
                          contentDetails.user_comments != '' &&
                          contentDetails.user_comments != null
                        "
                      >
                        {{ contentDetails.user_comments }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12" xl="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Receipt</b>
                      </span>
                      <br />
                      <v-card-actions>
                        <v-avatar
                          v-for="(item, i) in urlimage"
                          :key="i"
                          size="40"
                          :class="{ 'ma-3': i }"
                          tile
                        >
                          <v-icon
                            v-if="item.includes('webp' || 'WEBP')"
                            size="46"
                            color="primary"
                            @click="openImageInNewTab(item)"
                            >mdi-image</v-icon
                          >
                          <v-icon
                            v-if="item.includes('jpg' || 'JPG')"
                            size="46"
                            color="primary"
                            @click="openImageInNewTab(item)"
                            >mdi-image</v-icon
                          >
                          <v-icon
                            v-if="item.includes('jpeg' || 'JPEG')"
                            size="46"
                            color="primary"
                            @click="openImageInNewTab(item)"
                            >mdi-image</v-icon
                          >
                          <v-icon
                            v-if="item.includes('png' || 'PNG')"
                            size="46"
                            color="primary"
                            @click="openImageInNewTab(item)"
                            >mdi-image</v-icon
                          >
                          <v-icon
                            v-if="item.includes('docx' || 'doc')"
                            size="44"
                            color="blue"
                            @click="openImageInNewTab(item)"
                            >mdi-file-word</v-icon
                          >
                          <v-icon
                            v-if="item.includes('txt')"
                            size="44"
                            color="blue"
                            @click="openImageInNewTab(item)"
                            >mdi-file-document</v-icon
                          >
                          <v-icon
                            v-if="item.includes('pdf')"
                            size="44"
                            color="red"
                            @click="openImageInNewTab(item)"
                            class="ml-3"
                            >mdi-file-pdf</v-icon
                          >

                          <v-icon
                            v-if="item.includes('xls' || 'xlsx')"
                            size="44"
                            color="green"
                            @click="openImageInNewTab(item)"
                            >mdi-file-excel</v-icon
                          >
                        </v-avatar>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- <v-col cols="12" md="12" lg="12" xl="12">
                         
                        </v-col> -->
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";

import { apiCall } from "@/Views/APICALL/APIcall.js";
import moment from "moment";

export default {
  components: {
    OverleyProccessg,
  },
  data: () => ({
    itemsPerPage: 15,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    MessageStatus: false,
    remarkRule: [(v) => !!v || "required"],
    reason: "",
    search: "",
    contentDialog: false,
    overlay: false,
    on: "",
    UserList: [],
    usernames: 0,
    usernames_archive: 0,
    status: 4,
    status_archive: 4,
    statusitems: [
      {
        name: "All",
        value: 4,
      },
      {
        name: "Approved",
        value: 1,
      },
      {
        name: "Rejected",
        value: 2,
      },
      {
        name: "Unclaimed",
        value: 0,
      },
      {
        name: "In Progress",
        value: 3,
      },
      {
        name: "Personal",
        value: 6,
      },
      {
        name: "Official",
        value: 7,
      },
    ],
    downloadLoading: false,
    urlimage: [],
    Typeoftxn: "",
    headers: [
      { text: "Sl No", value: "sl_no", align: "start", sortable: false },
      {
        text: "User name",
        value: "user_name",

        sortable: false,
      },
      {
        text: "Card name/ Type",
        value: "card_name",
        align: "start",
        width: "3px",

        sortable: false,
      },
      {
        text: "Merchant name",
        value: "merchant_name",

        sortable: false,
      },
      {
        text: "Txn type",
        value: "txn_type",

        sortable: false,
      },

      {
        text: "Txn amount",
        value: "txn_amount",
        align: "start",
        width: "3px",

        sortable: false,
      },
      {
        text: "",
        value: "txn_currency",
        align: "start",
        width: "3px",

        sortable: false,
      },
      {
        text: "Billing amt(MYR)",
        value: "billing_amount",
        align: "start",
        width: "3px",

        sortable: false,
      },
      // {
      //   text: "Fee amt(MYR)",
      //   value: "fee_amount",
      //   align: "start",
      //   width: "3px",

      //   sortable: false,
      // },
      {
        text: "Card Balance",
        value: "card_balance",

        sortable: false,
      },
      {
        text: "Txn status/ On",
        value: "trxn_status",

        sortable: false,
      },
      // {
      //   text: " TRANSACTED ON",
      //   value: "txn_time",

      //   sortable: false,
      // },
      {
        text: "Settlement Status",
        value: "settlement_status",
      },
      {
        text: "Exp Status",
        value: "expense_status",
      },

      {
        text: "View",
        value: "View",
      },
    ],
    transectnStatus: 0,
    transectnStatus_archive: 0,
    transectionList: [
      {
        name: "All",
        value: 0,
      },
      {
        name: "ATM Cash Withdrawal",
        value: 1,
      },
      {
        name: "Purchase",
        value: 2,
      },
      {
        name: "Ecom Purchase",
        value: 3,
      },

      // {
      //   name: "Cash Withdrawal",
      //   value: 3,
      // },
      // {
      //   name: "Purchase",
      //   value: 2,
      // },
      // {
      //   name: "Wallet Credit",
      //   value: 1,
      // },
      // {
      //   name: "Wallet Debit",
      //   value: 7,
      // },
      // {
      //   name: "Balance inquiry",
      //   value: 5,
      // },
      // {
      //   name: "AFT",
      //   value: 11,
      // },
      // {
      //   name: "Refund",
      //   value: 4,
      // },
      //  {
      //   name: "Balance inquiry",
      //   value:5

      // },
      //   {
      //   name: "Account Verification",
      //   value:6

      // },
      //     {
      //   name: "Fee Debit",
      //   value:8

      // },
      //        {
      //   name: "Card Topup",
      //   value:9

      // },
      //              {
      //   name: "Wallet Transfer",
      //   value:10

      // },
    ],
    superaccess: false,
    contentDetails: {},
    modalEnd1: false,
    modalEndArchive: false,
    modalEnd1Archive: false,
    expanded: [],
    type: [],
    modalEnd: false,
    enddata: null,
    end_data: null,
    end_data_archive: null,
    enddata_archive: null,
    Transactionstatus: ["Approved", "Pending", "Rejected"],
    cardtransactions: [],
    Nodata: "",
    approveRej: false,
    Trans: {},
    checkaccessdata: {},
    SettleStatus: "",
    statusdescription: "",
    TxnAmount: "",
    TxnType: "",
    TxnCrrncy: "",
    BillingAmt: "",
    BillingCrrncy: "",
    UserName: "",
    MerchantName: "",
    txntime: "",
    FilterDialog: false,
    currentDate: null,
    maxEndDateArchive: null,
  }),
  created() {
    this.end_data = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.end_data_archive = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.currentDate = moment().format("YYYY-MM-DD");
    this.enddata = moment().format("YYYY-MM-DD");
    this.enddata_archive = moment().format("YYYY-MM-DD");
    this.maxEndDate = this.enddata;
    this.maxEndDateArchive = this.enddata_archive;
    this.getFundDetails(this.end_data, this.enddata);
    this.checkaccess();
  },
  methods: {
    setMinMaxToDate() {
      let tempMaxDate = moment(this.end_data, "YYYY-MM-DD")
        .add(12, "months")
        .format("YYYY-MM-DD");
      this.maxEndDate =
        this.currentDate < tempMaxDate ? this.currentDate : tempMaxDate;

      this.enddata = this.maxEndDate;
    },
    setMinMaxToDateArchive() {
      let tempMaxDate = moment(this.end_data_archive, "YYYY-MM-DD")
        .add(12, "months")
        .format("YYYY-MM-DD");
      this.maxEndDateArchive =
        this.currentDate < tempMaxDate ? this.currentDate : tempMaxDate;

      this.enddata_archive = this.maxEndDateArchive;
    },
    back() {
      this.$router.push("/Dashboard");
    },
    newww(item) {
      // console.log("item", item);
      this.approveRej = true;
      this.Trans = item;
    },
    async showContent(item) {
      // this.contentDialog = true;
      // this.contentDetails = item;
      this.TxnType = item.txn_type;
      this.TxnAmount = item.txn_amount;
      this.TxnCrrncy = item.txn_currency;
      this.BillingAmt = item.billing_amount;
      this.BillingCrrncy = item.billing_currency;
      this.statusdescription = item.status_description;
      this.UserName = item.user_name;
      this.MerchantName = item.merchant_name;
      this.txntime = item.txn_time;
      this.Typeoftxn = item.type;
      this.SettleStatus = item.settlement_status;

      var inputData = {
        method_name: "CTRANS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GCDTRANSD",
          txn_id: item.txn_id,
        },
      };

      var responseData = await apiCall(inputData);

      if (responseData.data.data) {
        this.contentDetails = responseData.data.data[0];
        if (this.contentDetails.recipt_urls != null) {
          this.urlimage = this.contentDetails.recipt_urls;
        }
      }

      this.contentDialog = true;
      // this.contentDetails = item;
      // console.log(" this.contentDetails", this.contentDetails);
    },

    async getFundDetailsPagination(start, end) {
      if (this.cardtransactions.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;
        // console.log("daf", this.pageCount);
        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "CTRANS",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "GCDTRANSLIST",
            corp_id: this.$store.getters.get_corpid,
            user_id: this.usernames,
            search_text: this.search,
            from_date: start,
            to_date: end,
            txn_type: this.transectnStatus == 0 ? 0 : this.transectnStatus,
            status: this.status,
          },
        };

        var responseData = await apiCall(inputData);

        this.cardtransactions = this.cardtransactions.concat(
          responseData.data.data
        );
      }
    },
    async getFundDetails(start, end) {
      this.pageCount = 0;
      var inputData = {
        method_name: "CTRANS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GCDTRANSLIST",
          corp_id: this.$store.getters.get_corpid,
          user_id: this.usernames,
          search_text: this.search,
          from_date: start,
          to_date: end,
          txn_type: this.transectnStatus == 0 ? 0 : this.transectnStatus,
          status: this.status,
        },
      };

      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        this.cardtransactions = responseData.data.data;
        // console.log(this.cardtransactions.length);
        this.totalCount = responseData.data.data[0].total_count;
        // console.log(this.totalCount);

        this.overlay = false;
      } else if (responseData.data.status == "NOREC") {
        this.cardtransactions = [];
        this.Nodata = responseData.data.status_msg;
        this.overlay = false;
      }
    },
    async getEmpDetails() {
      var inputData = {
        method_name: "CORPFUND",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCARDUSERS",
          search_text: "",
          corp_id: this.$store.getters.get_corpid,
          type: "0",
        },
      };
      var responseData = await apiCall(inputData);

      this.UserList =
        responseData.data.data == null ? [] : responseData.data.data;

      this.UserList.unshift({
        full_name: "All",
        userid: 0,
      });
    },
    openFilterDialog() {
      this.FilterDialog = true;
    },

    async getMessageDialog() {
      this.ExportFilterDataAPi(this.end_data_archive, this.enddata_archive);
    },
    ArchiveMode() {
      this.MessageStatus = false;
      this.$emit("clicked");
    },
    closeFilterDialog() {
      this.FilterDialog = false;
    },
    async ExportFilterDataAPi(start, end) {
      var inputData = {
        method_name: "CTRANS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          logged_user_id: this.$store.getters.get_userid,

          action: "TRANS_EXPORT",
          corp_id: this.$store.getters.get_corpid,
          user_id: this.usernames_archive,
          search_text: "",
          from_date: start,
          to_date: end,
          txn_type:
            this.transectnStatus_archive == 0
              ? 0
              : this.transectnStatus_archive,
          status:
            this.transectnStatus_archive == 1
              ? null
              : this.transectnStatus_archive == 7
              ? null
              : this.status_archive,
          initiated_from: 2,
        },
      };
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        this.MessageStatus = true;
      }
    },
    contentDialogclose() {
      this.contentDialog = false;
      this.urlimage = [];
    },
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CRDTRANS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        // this.getFundDetails(this.end_data, this.enddata);
        this.getEmpDetails();
      }
    },

    openImageInNewTab(url) {
      window.open(url, "_blank");
    },
    async approveRejTrans() {
      if (this.$refs.form.validate()) {
        var inputData = {
          method_name: "CTRANS",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "APRTRANS",
            txn_id: this.Trans.txn_id,
            status: 7,
            comments: this.reason,
            logged_user_id: this.$store.getters.get_userid,
          },
        };
        var responseData = await apiCall(inputData);
        if (responseData.data.status == "00") {
          this.approveRej = false;
          this.$refs.form.reset();
          this.overlay = false;
          this.getFundDetails();
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.getFundDetails();
          this.approveRej = false;
          this.overlay = false;
        }
      }
    },
    approveRejDialog() {
      this.approveRej = false;
      this.$refs.form.reset();
      this.getFundDetails(this.end_data, this.enddata);
    },
    async rejectTrans() {
      if (this.$refs.form.validate()) {
        var inputData = {
          method_name: "CTRANS",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "APRTRANS",
            txn_id: this.Trans.txn_id,
            status: 6,
            comments: this.reason,
            logged_user_id: this.$store.getters.get_userid,
          },
        };
        var responseData = await apiCall(inputData);
        if (responseData.data.status == "00") {
          this.approveRej = false;
          this.$refs.form.reset();
          this.overlay = false;
          this.getFundDetails();
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.approveRej = false;
          this.overlay = false;
          this.getFundDetails();
        }
      }
    },
  },
};
</script>

<style>
.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}

.cursor {
  cursor: pointer;
}
</style>
